import React from 'react'
import { Input } from 'antd';
import '../Input/Input.css'
import 'antd/dist/antd.css';

function InputField({type, placeholder, name, value, onChange, id, suffix, className,onInput,onKeyPress,onKeyDown,maxLength,disabled,onmousedown }) {
  return (
    <div>
      <Input
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        id={id}
        suffix={suffix}
        type={type}
        disabled={disabled}
        onInput={onInput}
        className={className}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        onMouseDown={onmousedown}
        maxLength={maxLength}
      />
    </div>
  )
}

export default InputField